import { Feather } from "lucide-react";
import { NAV_LINKS, SOCIALS } from "@/lib/site";
import { scrollToId } from "@/lib/lenis";

export default function Footer() {
  return (
    <footer className="border-t border-gold/20 bg-lake-deep" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <Feather className="h-5 w-5 text-gold" strokeWidth={1.5} />
              <span className="font-serif text-lg text-parchment-ivory">
                Il Segreto <span className="text-gold-shimmer">del Lago</span>
                <span className="ml-2 align-middle font-sans text-[9px] uppercase tracking-[0.3em] text-gold/70">
                  La Saga
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-parchment-ivory/50">
              La saga fantasy storica di Patrizia Franzina, tra leggenda e amore, sulle rive del
              Lago d'Orta. Il primo romanzo è in libreria da novembre 2026.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-gold">Esplora</p>
            <nav className="mt-4 grid grid-cols-2 gap-2" aria-label="Collegamenti piè di pagina">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="text-left text-sm text-parchment-ivory/60 transition-colors hover:text-gold-shimmer"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-gold">Segui la saga</p>
            <div className="mt-4 flex flex-col gap-2">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  data-testid={s.testid}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-parchment-ivory/60 transition-colors hover:text-gold-shimmer"
                >
                  {s.label}{" "}
                  {s.handle && <span className="text-parchment-ivory/35">· {s.handle}</span>}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="gold-line mt-12 w-full opacity-50" />
        <div className="mt-6 flex flex-col items-center justify-between gap-3 sm:flex-row">
          <p className="text-xs text-parchment-ivory/40">
            © 2026 Il Segreto del Lago — La Saga · Patrizia Franzina. Pubblicato da{" "}
            <a
              data-testid="footer-publisher-link"
              href="https://www.hever.it/autoridomani/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold-shimmer/80 underline decoration-gold/40 underline-offset-4 transition-colors hover:text-gold-shimmer"
            >
              Hever Edizioni
            </a>
            . Tutti i diritti riservati.
          </p>
          <a
            data-testid="footer-press-mail"
            href="mailto:autrice@ilsegretodellago.com"
            className="text-xs text-parchment-ivory/40 transition-colors hover:text-gold-shimmer"
          >
            autrice@ilsegretodellago.com
          </a>
        </div>
      </div>
    </footer>
  );
}
